import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CpClaimRequestModel } from '../../helpers/objects/request/claim/cp-claim-request-model';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { CpClaimResponseModel } from '../../helpers/objects/response/claim/cp-claim-response-model';
import { CpClaimDetailModel } from '../../helpers/objects/dto/claim/claim-detail/cp-claim-detail-model';
import { CpAuthorizationsDocumentsTextRequestModel } from '../../helpers/objects/request/authorizations-documents-text/cp-authorizations-documents-text-request-model';
import { CpAuthorizationsRequestModel } from '../../helpers/objects/request/authorizations/cp-authorizations-request-model';
import { CpDocumentModel } from '../../helpers/objects/dto/document/cp-document-model';

@Injectable({
  providedIn: 'root'
})
export class CpAuthorizationsService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  private dataLoadedSubject = new BehaviorSubject<boolean>(true);
  readonly dataLoaded$: Observable<boolean> = this.dataLoadedSubject.asObservable();


  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  setDataLoaded(loaded: boolean): void {
    this.dataLoadedSubject.next(loaded);
  }

  getAuthorizationsDocumentsText(body: CpAuthorizationsDocumentsTextRequestModel): Observable<string> {
    const contract = atob(sessionStorage.getItem('contract')!);

    return this.http
      .post<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/authorizations-documents-texts', body)
      .pipe(map((response) => response.body.documentTexts as string));
  }
  getAll(token: string, request: CpClaimRequestModel): Observable<CpClaimResponseModel> {
    const params = new HttpParams({
      fromObject: request as any
    });

    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/authorizations', { params })
      .pipe(map((response) => response.body as CpClaimResponseModel));
  }
  getDetails(token: string, clinicCase: string): Observable<CpClaimDetailModel> {
    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/authorizations/' + encodeURIComponent(clinicCase))
      .pipe(map((response) => response.body as CpClaimDetailModel));
  }
  getFormDocuments() {
    const contract = atob(sessionStorage.getItem('contract')!);
    return this.http
      .get<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/authorizations-form-documents')
      .pipe(map((response) => response.body.Documents as CpDocumentModel[]));
  }

  edit(data: any, token: string, clinicCase: string): Observable<any> {
    return this.http
      .put<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(token) + '/authorizations/' + encodeURIComponent(clinicCase), data)
      .pipe(map((response) => response));
  }

  create(body: CpAuthorizationsRequestModel): Observable<number> {
    const contract = atob(sessionStorage.getItem('contract')!);

    return this.http
      .post<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/authorizations', body)
      .pipe(map((response) => response.body.clinicCase as number));
  }

  validatePatient(body:any): Observable<any> {
    const contract = atob(sessionStorage.getItem('contract')!);
    return this.http
      .post<any>(this.appConfig.api + 'contracts/' + encodeURIComponent(contract) + '/authorizations/validate-patient', body)
      .pipe(map((response) => response));
  }
}
